export default [
  {
    title: 'مدیریت کاربران',
    icon: 'UsersIcon',
    children: [
      {
        title: 'لیست کاربران',
        icon: 'UsersIcon',
        route: 'Users_List',
        permission: 'users.index',
      },
      {
        title: 'ایجاد کاربر',
        icon: 'UserPlusIcon',
        route: 'Users_Create',
        permission: 'users.create',
      },
      {
        title: 'نقش ها و دسترسی ها',
        icon: 'UsersIcon',
        route: 'RolesAndPermissions_ManagedInDash',
        permission: 'roles.index',
      },
      {
        title: 'واحد سازمانی',
        icon: 'UsersIcon',
        children: [
          {
            title: 'لیست واحد ها',
            permission: 'organizations.index',
            route: 'Organization_Unit_List',
          },
          {
            title: 'ایجاد واحد',
            permission: 'organizations.store',
            route: 'Organization_Unit_Create',
          },
        ]
      },

    ]
  },
  {
    title: 'لاگ ورود',
    icon: 'UserIcon',
    route: 'Users_login_logs',
  },
]
